import Base from '../base';

import { getTrackingData, pushTrackingData } from '../../tracking/utils';

import { default as createMessage, messageLabels } from './calculator-message-factory';
import formEvents from './calculator-forms/calculator-form-events';
import formFactory from './calculator-forms/calculator-form-factory';
import tableFactory from './calculator-table/calculator-table-factory';

class Calculator extends Base {
	set isLoading(loading) {
		this.el.classList.toggle('is-loading', loading);
	}

	start() {
		const { type = 'default' } = this.options;

		this.form = formFactory(this.refs.form, type);
		this.table = tableFactory(this.refs.table, type);

		this.onFormSubmit = this.onFormSubmit.bind(this);
		this.onFormChange = this.onFormChange.bind(this);

		this.form.el.addEventListener(formEvents.FORM_SUBMITTED, this.onFormSubmit);
		this.form.el.addEventListener('change', this.onFormChange);

		this.formChangeTracked = false;
	}

	onFormSubmit(e) {
		const { detail: formData } = e;

		this.hideMessages();
		this.update(formData);
	}

	onFormChange(e) {
		this.form.el.removeEventListener('change', this.onFormChange);

		const trackingData = getTrackingData(this.el);

		pushTrackingData(trackingData);
	}

	async update(formData) {
		this.isLoading = true;

		try {
			const response = await this.fetchCalculatedValues(formData);

			this.updateTable(response);
			this.updateMessages(response);
		} catch (e) {
			console.warn('error while fetching:', e);
		} finally {
			this.isLoading = false;
		}
	}

	fetchCalculatedValues(formData) {
		return fetch(this.form.el.action, {
			credentials: 'same-origin',
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
				'content-type': 'application/json',
			},
			method: 'POST',
			body: JSON.stringify(formData),
		}).then(res => res.json());
	}

	hideMessages() {
		this.queryAll('.js-message').forEach(el => el.classList.add('is-hidden'));
	}

	updateMessages(response) {
		const { options } = response;

		// filter only keys with value 'true'
		// and keys that has a resource label
		Object
			.keys(options)
			.filter(key => options[key])
			.filter(key => Object.keys(messageLabels).includes(key))
			.forEach((key) => {
				this.displayMessage(key);
			});
	}

	displayMessage(key) {
		const messageClass = `.js-${key}`;
		const existingMessage = this.query(messageClass);

		if (existingMessage) {
			existingMessage.classList.remove('is-hidden');

			return;
		}

		const message = createMessage(key);

		message.classList.add('js-message', messageClass);
		this.refs.messagesContainer.appendChild(message);
	}

	updateTable(response) {
		this.table.update(response);
	}
}


export default Calculator;
